
import { defineComponent, ref } from "vue";
export default defineComponent({
  props: {
    taste: {
      type: Number,
      default: 4
    },
    tasteDesc: {
      type: String,
      default: ""
    },
    brix: {
      type: [String, Number],
      default: 0
    }
  },
  setup(props) {
    const arrTemp1: number[] = [];
    const arrTemp2: number[] = [];
    const notaste: number = 5 - props.taste;
    for (let i = 0; i < props.taste; i++) {
      arrTemp1.push(i);
    }
    for (let i = 0; i < notaste; i++) {
      arrTemp2.push(i);
    }
    const arrTaste = ref(arrTemp1);
    const arrNotaste = ref(arrTemp2);
    return {
      arrTaste,
      arrNotaste
    };
  }
});
